import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

export interface Recordatorio {
    titulo: string;
    horario: string;
    color?: string;
    textoColor?: string;
    url?: string; // si existe, se muestra el ojo al lado del horario
}

@Component({
    selector: 'app-card-recordatorios',
    standalone: false,
    templateUrl: './card-recordatorios.component.html',
    styleUrls: ['./card-recordatorios.component.scss']
})
export class CardRecordatoriosComponent implements OnInit {
    @Input() titulo: string = 'Today';
    @Input() recordatorios: Recordatorio[] = [];

    /** Tooltip templado (desktop) / mismo contenido en popover (móvil) */
    @Input() headerTooltip?: TemplateRef<any>;
    @Input() headerTooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
    @Input() headerTooltipStyleClass: string = 'gv-tooltip';

    @Input() tooltipBold: string = 'Gerenciamientos';
    @Input() tooltipText: string = 'que están ocurriendo en este momento.';

    @Input() emptyIcon: string = 'pi pi-check-circle';
    @Input() emptyMessage: string = 'Sin elementos activos ahora';

    isMobile = false;

    constructor(private bp: BreakpointObserver) {}

    ngOnInit(): void {
        this.bp.observe([Breakpoints.Handset]).subscribe((s) => (this.isMobile = s.matches));
    }
}
